exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message{position:fixed;z-index:41;left:0;right:0;top:0;margin-left:auto;margin-right:auto;-webkit-animation:animatetop 2s;animation:animatetop 2s}.message .delete:after,.message .delete:before{background-color:#fff}@-webkit-keyframes animatetop{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes animatetop{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11cadc72","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/front/components/messages.vue
// module id = R+H3
// module chunks = 1